import { ReviewModel } from '@loavies/c2c-models'
import { mapUser } from './user-mappers'

/**
 * @param {Array} reviews
 * @returns {loavies.models.review.ReviewModel[]}
 */
export function mapReviews(reviews) {
  return reviews.map(review => mapReview(review))
}

/**
 * @param {Object} review
 * @returns {loavies.models.review.ReviewModel}
 */
export function mapReview(review) {
  return new ReviewModel({
    id: review.id.uuid,
    type: review.attributes.type,
    state: review.attributes.state,
    rating: review.attributes.rating,
    content: review.attributes.content,
    createdAt: new Date(review.attributes.createdAt),
    author: mapUser(review.author),
    subject: mapUser(review.subject),
  })
}
